<template>
  <div id="middleWrapM" class="container">
    <t-toggle @change="onChange" onClass="active" :activateIndex="activate">
      <div>
        <t-toggle-button
          v-for="(item, idx) in tabs"
          :hash="`#tab${idx + 1}`"
          :key="`ttoggle-button--key${idx}`"
          >{{ item }}</t-toggle-button
        >
      </div>
      <div>
        <t-toggle-content>1111111111111</t-toggle-content>
        <t-toggle-content>2222222222222</t-toggle-content>
        <t-toggle-content>3333333333333</t-toggle-content>
      </div>
    </t-toggle>
  </div>
</template>

<script>
import { TToggle, TToggleButton, TToggleContent } from '@/components/TToggle';

export default {
  components: {
    TToggle,
    TToggleButton,
    TToggleContent
  },
  data() {
    return {
      tabs    : ['tab1', 'tab2', 'tab3'],
      activate: 0
    };
  },
  computed: {
    title() {
      return this.tabs[this.activate];
    }
  },
  mounted() {},
  methods: {
    onChange({ act }) {
      this.activate = act;
    }
  }
};
</script>

<style lang="scss" scoped>
.t-toggle-container .t-toggle__button.on {
  background-color: gray;
}

.t-toggle-container .t-toggle__button.active {
  background-color: red;
}

.t-toggle-container .t-toggle__content {
  display: none;
}

.t-toggle-container .t-toggle__content.active {
  display: block;
}
</style>
